import React from 'react'
import propTypes from 'prop-types'
import {get, isNil, isEqual} from 'lodash'
import * as contactUtils from 'helpers/contacts'
import {AsyncSelectField, SelectField} from 'components/selectField'
import {api} from 'services/api'
import {isDormantContact, TYPE} from 'helpers/contacts'
import {t} from "helpers/language"

const standardParams = {sortColumn: 'forename', sortDirection: 'asc'}

class ContactSelectField extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.getInitialState()
    this.selectRef = React.createRef()
  }

  getInitialState = () => {
    return {
      contacts: null,
    }
  }

  focus = () => {
    if (this.selectRef.current) this.selectRef.current.focus()
  }

  componentDidMount = () => {
    const {companyId} = this.props
    if (companyId) this.setWithCompany(companyId)
  }

  componentDidUpdate(prevProps) {
    const {companyId} = this.props
    if (!isEqual(prevProps.companyId, companyId)) {
      this.setWithCompany(companyId)
    }
  }

  filterMainContacts = (contacts) => {
    return contacts
        .slice()
        .filter(contact => contact.type.id !== TYPE.main)
  }

  setWithCompany = (companyId) => {
    if (companyId) {
      // Load contacts for company
      this.setState({contacts: []})
      api.contact.get({companyId, ...this.getParams()}, this.getFields()).then(response => {
        api.handleResponseNonYield(
            response, (key, data) => {
              let contacts = data.result || []
              if (this.props.mains === false) contacts = this.filterMainContacts(contacts)
              this.setState({contacts})
            },
            (key, message) => {
              console.error('Failed to load contacts for company', message)
            }
        )
      })
    } else {
      this.setState({contacts: null})
    }
  }

  getFields = () => {
    const {fields, companyId} = this.props
    let ret = {
      forename: true,
      surname: true,
      email: true,
      type: true,
      ...fields,
    }

    if (!companyId) {
      ret = {
        ...ret,
        company: {
          name: true,
          type: true,
          ...ret.company,
        },
      }
    }

    return ret
  }

  isOptionDisabled = (contact) => {
    const {isOptionDisabled} = this.props
    return isNil(isOptionDisabled)
        ? false
        : isOptionDisabled(contact)
  }

  getOptions = (contacts) => {
    const {companyId, mains} = this.props
    contacts = contacts.map(contact => {
      let label = contactUtils.getContactLabel(contact, !companyId)
      const type = get(contact, 'type', TYPE.general)
      if (isDormantContact(type))
        label += ' [DORMANT]'

      return {
        value: contact.id,
        label,
        contact,
        disabled: this.isOptionDisabled(contact),
      }
    })

    return mains === false
        ? contacts.filter(contact => contact.type !== TYPE.main)
        : contacts
  }

  getParams = () => {
    const {dormants, params} = this.props
    return {
      ...standardParams,
      ...params,
      dormants,
    }
  }

  render() {
    const {placeholder, styles, ...otherProps} = this.props
    const {contacts} = this.state

    if (contacts) {
      return (
          <SelectField
              {...otherProps}
              ref={this.selectRef}
              placeholder={placeholder}
              options={this.getOptions(contacts)}
              styles={styles}
          />
      )
    } else {
      return (
          <AsyncSelectField
              {...otherProps}
              ref={this.selectRef}
              placeholder={placeholder}
              params={this.getParams()}
              fields={this.getFields()}
              onLoad={api.contact.get}
              onOptions={this.getOptions}
          />
      )
    }
  }
}

ContactSelectField.propTypes = {
  fields: propTypes.object,
  params: propTypes.object,
  dormants: propTypes.bool,
  mains: propTypes.bool,
  main: propTypes.bool,
  multi: propTypes.bool,
  placeholder: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  companyId: propTypes.oneOfType([
    propTypes.number,
    propTypes.arrayOf(propTypes.number),
  ]),
  isOptionDisabled: propTypes.func,
  styles: propTypes.object,
}

ContactSelectField.defaultProps = {
  dormants: false,
  mains: true,
  placeholder: t('Find a Contact'),
  multi: false,
  isOptionDisabled: null,
}

export default ContactSelectField
